// Generated file - do not change manually!
/**
 * Different types of Button.
 */
export var LinkDesign;
(function (LinkDesign) {
    /**
     * default type (no special styling)
     */
    LinkDesign["Default"] = "Default";
    /**
     * emphasized type
     */
    LinkDesign["Emphasized"] = "Emphasized";
    /**
     * subtle type (appears as regular text, rather than a link)
     */
    LinkDesign["Subtle"] = "Subtle";
})(LinkDesign || (LinkDesign = {}));
